import type { RecencyFilter as RecencyFilterValue } from './sessionGrouping';

const OPTIONS: { value: RecencyFilterValue; label: string }[] = [
  { value: '24h', label: 'Last 24 hours' },
  { value: 'week', label: 'Last week' },
  { value: 'month', label: 'Last month' },
  { value: 'all', label: 'All time' },
];

/**
 * Recency filter dropdown for the Sessions Surface. Applied client-side over the
 * all-time result; default "All time" per the approved Timeline Filter Rules
 * decision (CU-86ahjxn9e item 6).
 */
export function RecencyFilter({
  value,
  onChange,
}: {
  value: RecencyFilterValue;
  onChange: (_value: RecencyFilterValue) => void;
}) {
  return (
    <label className="flex items-center gap-2 text-sm text-gray-600">
      <span>Show:</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as RecencyFilterValue)}
        className="rounded-md border border-gray-300 bg-white px-2 py-1 text-sm"
      >
        {OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}

export default RecencyFilter;
